import { PlatformInfra } from '@wix/editor-platform-worker';
import {
  DocumentServices,
  HostAPI,
  HostAPIClassic,
  HostAPIEditorX,
  HostAPIStudio,
  HostType,
  HostAPIEditor3,
} from '@wix/editor-platform-private-api';
import {
  createEditorPlatformInternalError,
  EditorPlatformInternalErrorCode,
} from '@wix/public-editor-platform-errors';
import { IExperimentsApiAdapter } from '../utils/experimentsApiAdapter';
import { EditorPointerAPI } from '@wix/editorx-core-api';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';
import { EditorPointerServiceAPI } from '@wix/editor-platform-feature-store';

const getHostAPI = <THostType extends HostType>(
  hostType: THostType,
  platformApiMethods: PlatformApiMethods,
): HostAPI => {
  switch (hostType) {
    case HostType.Classic:
      return new HostAPIClassic(platformApiMethods) as unknown as HostAPI;
    case HostType.Editorx:
      return new HostAPIEditorX(platformApiMethods) as unknown as HostAPI;
    case HostType.Studio:
      return new HostAPIStudio(platformApiMethods) as unknown as HostAPI;
    case HostType.Editor3:
      return new HostAPIEditor3(platformApiMethods) as unknown as HostAPI;
    case HostType.MobileStudio:
      return new HostAPIStudio(platformApiMethods) as unknown as HostAPI;
    default:
      throw createEditorPlatformInternalError(
        EditorPlatformInternalErrorCode.UnexpectedError,
      ).withHost(hostType);
  }
};

export function initNewPlatformInfra({
  host,
  __temporaryPlatformApiMethods,
  documentServicesAPI,
  experimentsAPI,
  editorPointerAPI,
}: {
  host: HostType;
  documentServicesAPI: DocumentServices;
  experimentsAPI: IExperimentsApiAdapter;
  __temporaryPlatformApiMethods: PlatformApiMethods;
  editorPointerAPI?: EditorPointerServiceAPI;
}) {
  if (!Object.values(HostType).includes(host)) {
    throw createEditorPlatformInternalError(
      EditorPlatformInternalErrorCode.UnexpectedError,
      `Could not determine host type`,
    ).withHost(host);
  }

  return new PlatformInfra(host, {
    hostAPI: getHostAPI(host, __temporaryPlatformApiMethods),
    documentServicesAPI,
    experimentsAPI,
    editorPointerAPI,
  });
}
